"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserBasicInfoByEmail = void 0;
const getUserBasicInfoByEmail = async (supabase, email) => {
    const { data, error } = await supabase
        .from("user_profiles")
        .select(` 
        id,
        first_name,
        last_name,
        email,
        display_currency`)
        .eq("email", email.toLowerCase())
        .single();
    if (error) {
        return null;
    }
    if (!data) {
        return null;
    }
    return data;
};
exports.getUserBasicInfoByEmail = getUserBasicInfoByEmail;
